import { GeofencesEditPage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeofencesEditRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      permission="journeys/geofences/edit"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geosets/$geosetId/geofences',
          params: { workspaceId: params.workspaceId, geosetId: params.geosetId ?? '' },
        }).href
      }
    >
      <GeofencesEditPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId')(
  {
    component: GeofencesEditRoute,
  },
);
